/* Native forms and option URLs are intentional: Shopify owns prices, inventory and cart mutations. */
(() => {
  if (window.delellisThemeReady) return;
  window.delellisThemeReady = true;
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.mobile-nav[open], .nav-item details[open], .filter[open]').forEach(details => {
      details.open = false;
      details.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('click', event => {
    const guideLink = event.target.closest('[data-find-ritual]');
    const guide = document.querySelector('[data-coffee-guide]');
    if (guideLink && guide) { event.preventDefault(); guide.scrollIntoView(); guide.focus({preventScroll:true}); }
    const mobileLink = event.target.closest('.mobile-nav nav a');
    if (mobileLink) mobileLink.closest('details').open = false;
    document.querySelectorAll('.nav-item details[open], .filter[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  const galleries = new Map();
  function initGalleries(scope = document) {
    const roots = [...scope.querySelectorAll('[data-product-gallery]')];
    if (scope.matches?.('[data-product-gallery]')) roots.unshift(scope);
    roots.forEach(root => {
      if (galleries.has(root)) return;
      const track = root.querySelector('[data-gallery-track]');
      const slides = [...root.querySelectorAll('[data-gallery-slide]')];
      if (!track || slides.length < 2) return;
      const previous = root.querySelector('[data-gallery-prev]');
      const next = root.querySelector('[data-gallery-next]');
      const current = root.querySelector('[data-gallery-current]');
      const controller = new AbortController();
      const listen = (element, type, fn, options = {}) => element.addEventListener(type, fn, { ...options, signal: controller.signal });
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0;
      let targetIndex = 0;
      let frame = 0;
      let settleTimer;
      let drag = null;
      const nearest = () => track.clientWidth ? Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth))) : index;
      const sync = () => {
        frame = 0;
        const active = nearest();
        if (active !== index) {
          slides[index].querySelectorAll('video').forEach(video => video.pause());
          index = active;
          current.textContent = String(index + 1);
        }
        previous.disabled = index === 0;
        next.disabled = index === slides.length - 1;
        slides.forEach((slide, i) => { slide.inert = i !== index; });
      };
      const go = (position, instant = false) => {
        targetIndex = Math.max(0, Math.min(slides.length - 1, position));
        track.scrollTo({ left: slides[targetIndex].offsetLeft, behavior: instant || reducedMotion.matches ? 'auto' : 'smooth' });
      };
      listen(previous, 'click', () => go(targetIndex - 1));
      listen(next, 'click', () => go(targetIndex + 1));
      listen(track, 'scroll', () => {
        if (!frame) frame = requestAnimationFrame(sync);
        clearTimeout(settleTimer);
        settleTimer = setTimeout(() => { targetIndex = nearest(); }, 150);
      }, { passive: true });
      listen(track, 'keydown', event => {
        if (event.target !== track) return;
        const destinations = { ArrowLeft: index - 1, ArrowRight: index + 1, Home: 0, End: slides.length - 1 };
        if (!(event.key in destinations)) return;
        event.preventDefault();
        go(destinations[event.key]);
      });
      // Touch and trackpad gestures use native scrolling. Mouse dragging provides
      // the same gesture without interfering with video or model controls.
      listen(track, 'pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('video, iframe, model-viewer, button, a, input')) return;
        drag = { id: event.pointerId, x: event.clientX, left: track.scrollLeft, moved: false };
        track.setPointerCapture(event.pointerId);
      });
      listen(track, 'pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;
        const distance = event.clientX - drag.x;
        if (Math.abs(distance) > 4) { drag.moved = true; track.classList.add('is-dragging'); }
        if (!drag.moved) return;
        event.preventDefault();
        track.scrollLeft = drag.left - distance;
      });
      const endDrag = () => {
        if (!drag) return;
        const position = nearest();
        const moved = drag.moved;
        const pointerId = drag.id;
        drag = null;
        track.classList.remove('is-dragging');
        if (track.hasPointerCapture(pointerId)) track.releasePointerCapture(pointerId);
        if (moved) go(position);
      };
      listen(track, 'pointerup', endDrag);
      listen(track, 'pointercancel', endDrag);
      listen(track, 'lostpointercapture', endDrag);
      listen(track, 'dragstart', event => { if (event.target.tagName === 'IMG') event.preventDefault(); });
      let resize;
      if ('ResizeObserver' in window) {
        resize = new ResizeObserver(() => go(index, true));
        resize.observe(track);
      }
      track.classList.add('is-draggable');
      root.querySelectorAll('[data-gallery-controls]').forEach(control => { control.hidden = false; });
      sync();
      galleries.set(root, () => {
        controller.abort();
        resize?.disconnect();
        cancelAnimationFrame(frame);
        clearTimeout(settleTimer);
      });
    });
  }
  initGalleries();
  document.addEventListener('shopify:section:load', event => initGalleries(event.target));
  document.addEventListener('shopify:section:unload', event => {
    galleries.forEach((cleanup, root) => {
      if (event.target.contains(root)) { cleanup(); galleries.delete(root); }
    });
  });
  const cartObservers = new Map();
  function initCart(scope = document) {
    const roots = [...scope.querySelectorAll('[data-cart-root]')];
    if (scope.matches?.('[data-cart-root]')) roots.unshift(scope);
    roots.forEach(root => {
      if (cartObservers.has(root)) return;
      const bar = root.querySelector('[data-cart-bar]');
      const cta = root.querySelector('[data-cart-cta]');
      if (!bar || !cta || !('IntersectionObserver' in window)) return;
      const mobile = window.matchMedia('(max-width: 740px)');
      let visible = true;
      const update = () => { bar.hidden = !mobile.matches || visible; bar.inert = bar.hidden; };
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        update();
      });
      observer.observe(cta);
      mobile.addEventListener('change', update);
      cartObservers.set(root, () => { observer.disconnect(); mobile.removeEventListener('change', update); });
    });
  }
  initCart();
  document.addEventListener('shopify:section:load', event => initCart(event.target));
  document.addEventListener('shopify:section:unload', event => {
    cartObservers.forEach((cleanup, root) => {
      if (event.target.contains(root)) { cleanup(); cartObservers.delete(root); }
    });
  });
  document.addEventListener('submit', event => {
    if (event.target.matches('.cart-items')) {
      if (event.target.dataset.submitting === 'true') { event.preventDefault(); return; }
      event.target.dataset.submitting = 'true';
      event.target.setAttribute('aria-busy', 'true');
      // Keep the submitter enabled: its name/value identifies the cart line update.
      return;
    }

    if (!event.target.matches('.product-form')) return;
    if (event.target.dataset.submitting === 'true') { event.preventDefault(); return; }
    event.target.dataset.submitting = 'true';
    const button = event.target.querySelector('[name="add"]');
    if (button) { button.setAttribute('aria-busy', 'true'); queueMicrotask(() => { button.disabled = true; }); }
  });
  window.addEventListener('pageshow', () => document.querySelectorAll('.product-form[data-submitting], .cart-items[data-submitting]').forEach(form => {
    delete form.dataset.submitting;
    form.removeAttribute('aria-busy');
    const button = form.querySelector('[aria-busy="true"]');
    if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
  }));
})();
